import { useContext } from 'react';
import type { FeatureFlag, FeatureFlags } from 'constants/feature-flags';
import { FeatureFlagsContext } from 'contexts/feature-flags-context';

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

export const useFeatureFlag = <T extends FeatureFlag>(flag: T): FeatureFlags[T] => useFeatureFlags().featureFlags[flag];
